<template lang="html">
    <div class="row">
        <div
            class="form-wrapper col-12 col-sm-8 col-lg-6"
            :style="{ 'padding-left': (marginContainer + 50) + 'px' }"
        >
            <div class="form">
                <FormDocument />
            </div>
            <div class="watermark">
                <svg
                    width="1215"
                    height="950"
                    viewBox="0 0 1215 950"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g opacity="0.3">
                        <path
                            opacity="0.2"
                            d="M1053.29 162.65C1010.27 110.095 961.38 54.4489 899.906 14.8396C847.42 -18.9732 787.623 12.8108 734.298 33.0019C712.728 41.117 691.038 49.3287 670.067 58.4098C662.398 61.6945 654.489 65.1724 649.696 71.2587C644.663 77.6348 652.212 86.4262 661.08 86.2329C668.629 86.0397 676.538 82.9483 683.249 80.5331C693.195 77.345 703.74 75.2196 714.166 73.5773C738.132 69.8096 762.578 68.2638 786.784 71.4519C829.564 75.7993 866.113 89.3244 896.431 111.931C926.749 134.634 968.81 178.687 1003.32 220.808C1029.09 252.302 1066.83 313.358 1078.22 357.412C1089.6 401.465 1089.96 447.354 1079.3 495.078C1068.51 542.803 1044.9 590.237 1008.35 637.189C971.805 684.237 918.84 726.261 849.337 763.166C792.416 793.5 732.74 816.88 670.547 833.303C608.354 849.726 543.165 851.175 474.98 837.844C434.597 829.535 396.61 814.754 361.259 793.404C255.208 729.546 114.045 526.862 144.003 433.925C149.875 413.638 159.821 395.475 174.081 379.342C188.341 363.208 204.159 349.973 221.535 339.829C228.964 335.868 245.501 327.173 240.468 318.092C233.398 305.243 213.386 315.387 203.32 319.735C157.904 337.027 71.864 384.559 26.807 402.431C10.5098 408.904 -8.30387 415.57 3.91903 435.471C13.5056 451.025 23.4517 467.158 31.4805 484.451C64.1947 554.685 110.57 620.959 161.738 683.464C236.514 774.759 349.636 877.743 477.257 919.96C613.027 964.883 764.376 958.41 896.071 907.305C1027.41 856.296 1141.37 765.677 1188.58 653.032C1233.64 545.508 1217.94 429.095 1165.1 325.628C1140.29 276.551 1089.36 206.703 1053.29 162.65Z"
                            fill="#33647E"
                        />
                    </g>
                </svg>
            </div>
        </div>
        <div class="image col-12 col-sm-4 col-lg-6"></div>
    </div>
    <div class="container" id="containerRef"></div>
</template>
<script>
import FormDocument from "./FormDocument.vue"

export default {
    components: {
        FormDocument
    },
    data() {
        return {
            marginContainer: 0
        }
    },
    created() {
        window.addEventListener("resize", this.eventResizeForContainer)
    },
    mounted() {
        this.eventResizeForContainer();
    },
    unmounted() {
        window.removeEventListener("resize", this.eventResizeForContainer);
    },
    methods: {
        eventResizeForContainer() {
            let containerRef = document.getElementById("containerRef")
            this.marginContainer = containerRef.offsetLeft;
        }
    },
}
</script>
<style lang="css" scoped>
.form-wrapper {
    padding-top: 70px;
    padding-bottom: 70px;
    padding-right: 100px;
    background: #f6f6f6;
    position: relative;
    overflow: hidden;
}
.form-wrapper .form {
    position: relative;
    z-index: 2;
}
.form-wrapper .watermark {
    display: inline;
    position: absolute;
    right: 0;
    top: -300px;
    width: 600px;
    z-index: 1;
}
.form-wrapper .watermark svg {
    width: 100%;
}
.image {
    background-image: url(https://i.ibb.co/MhzbWmw/Footer-Doc.png);
    background-size: cover;
}

@media (max-width: 768px) {
    .form-wrapper {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }
}

@media (max-width: 576px) {
    .image {
        height: 160px;
    }
}
</style>